/**
 * 行情单页底部指数弹框
 */ 
import React, { useEffect, useState } from "react"
import { getMarketSource, loadZsData } from "../../../modules/quote/web"
import { store as AStore } from "../../page/a/store"
import { store as BStore } from "../../page/b/store"
import { PageType } from "../pagetype"
import { quotedata } from "../quotedata"
import { single_quote, quote_item_name } from "../quotedata/index"
import { iszq, iszs } from "../utils"
import "./index.less"

export function IndicesPopPanel(props: { pagetype: PageType; quotedata: quotedata; data: any; setIndicesData: Function; onClose: Function; setTrangleClass: Function }) {
  let [indices, setIndices] = useState<any>([])
  let [currentIndices, setCurrentIndices] = useState({ name: props.data.f58, code: props.data.f57, market: props.data.f107, selected: true })
  const defaultIndices = [
    { name: "上证指数", code: "000001", market: 1, selected: true },
    { name: "深证成指", code: "399001", market: 0, selected: false },
    { name: "创业板指", code: "399006", market: 0, selected: false },
  ]

  const drawFSChart = (quotecode: string) => {
    //调用绘图方法
    if (quotecode) {
      let chart = new window.EmchartsMobileTime(
        Object.assign(
          {
            container: "indexImg",
            code: quotecode,
            width: $("#indexImg").width(),
            height: 150,
            dpr: 2,
            showVMax: true,
          },
          null
        )
      )
      chart.draw()
    }
  }

  const clickIndices = async (item: any) => {
    let temp = indices.map((item: any) => {
      item.selected = false
      return item
    })
    item.selected = true
    setCurrentIndices(item)
    setIndices(temp)
    let data = await loadZsData(item.code, item.market, "")
    if (data) {
      props.setIndicesData(data)
    }
    drawFSChart(item.market + "." + item.code)
  }

  const clickClose = () => {
    props.onClose()
    props.setTrangleClass(false)
  }

  useEffect(() => {
    let _market = getMarketSource(props.quotedata.quotecode)
    if (!iszq(props.quotedata.market, props.quotedata.code, _market) && !iszs(props.quotedata.market, props.quotedata.code) && props.quotedata.market != 113) {
      if (props.pagetype == PageType.沪深A股) {
        if (single_quote[quote_item_name.板块代码](AStore.StockDetail).text && single_quote[quote_item_name.板块代码](AStore.StockDetail).text != "-" && single_quote[quote_item_name.板块名称](AStore.StockDetail).text && single_quote[quote_item_name.板块名称](AStore.StockDetail).text != "-") {
          let newIndices = [...defaultIndices, { name: single_quote[quote_item_name.板块名称](AStore.StockDetail).text, code: single_quote[quote_item_name.板块代码](AStore.StockDetail).text, market: 90, selected: false }]
          setIndices(newIndices)
        }else{
          setIndices(defaultIndices)
        }
      } else if (props.pagetype == PageType.B股) {
        if (single_quote[quote_item_name.板块代码](BStore.StockDetail).text && single_quote[quote_item_name.板块代码](BStore.StockDetail).text != "-" && single_quote[quote_item_name.板块名称](BStore.StockDetail).text && single_quote[quote_item_name.板块名称](BStore.StockDetail).text != "-") {
          let newIndices = [...defaultIndices, { name: single_quote[quote_item_name.板块名称](BStore.StockDetail).text, code: single_quote[quote_item_name.板块代码](BStore.StockDetail).text, market: 90, selected: false }]
          setIndices(newIndices)
        }else{
          setIndices(defaultIndices)
        }
      } else {
        setIndices(defaultIndices)
      }
    } else {
      setIndices(defaultIndices)
    }
    drawFSChart(defaultIndices[0].market + "." + defaultIndices[0].code)
  }, [])

  let timer: any = null
  useEffect(() => {
    timer && clearInterval(timer)
    timer = setInterval(async () => {
      let data = await loadZsData(currentIndices.code, currentIndices.market, "")
      if (data) {
        props.setIndicesData(data)
      }
      drawFSChart(currentIndices.market + "." + currentIndices.code)
    }, 30 * 1000)
    return () => {
      timer && clearInterval(timer)
    }
  }, [currentIndices])

  return (
    <div className="zhishu-pop">
      <div className="tit">
        {single_quote[quote_item_name.名称](props.data).element}
        {single_quote[quote_item_name.最新价_指数](props.data).element}
        {single_quote[quote_item_name.涨跌幅_指数](props.data).element}
        {single_quote[quote_item_name.涨跌额_指数](props.data).element}
        {single_quote[quote_item_name.成交额_指数](props.data).element}
        <i className="icon-trangle-down" onClick={clickClose}></i>
      </div>
      <div className="con">
        <div className="left-p emcharts-container" id="indexImg">
          <canvas className="zhishu-canvas"></canvas>
          <div className="loading-chart">加载中...</div>
        </div>
        <div className="right-p">
          {indices.map((item: any) => {
            return (
              <a
                href="#"
                className={props.data.f58 == item.name ? "active" : ""}
                key={item.code}
                onClick={(e) => {
                  e.preventDefault()
                  clickIndices(item)
                }}
              >
                {item.name}
              </a>
            )
          })}
        </div>
      </div>
    </div>
  )
}
